import { create } from 'zustand';

export interface AuthStoreState {
  // Auth credentials
  token: string | null;
  authId: string | null;

  // User info
  userId: string | null;
  orgId: string | null;
  orgName: string | null;
  region: string | null;
  role: string | null;
  team: string | null;
  userTitle: string | null;

  // Actions
  setAuth: (
    auth: Partial<Omit<AuthStoreState, 'setAuth' | 'clearAuth'>>
  ) => void;
  clearAuth: () => void;
}

const initialState = {
  token: null,
  authId: null,
  userId: null,
  orgId: null,
  orgName: null,
  region: null,
  role: null,
  team: null,
  userTitle: null,
};

// In-memory only store
// Data is populated by AuthProvider on each page load via Firebase
export const useAuthStore = create<AuthStoreState>()((set) => ({
  ...initialState,

  setAuth: (auth) =>
    set((state) => ({
      ...state,
      ...auth,
    })),

  clearAuth: () => set(initialState),
}));

// Non-hook accessors for use outside React components (e.g., in API calls)
export const authStoreActions = {
  getState: () => useAuthStore.getState(),
  getToken: () => useAuthStore.getState().token,
  getAuthId: () => useAuthStore.getState().authId,
  getUserId: () => useAuthStore.getState().userId,
  getOrgId: () => useAuthStore.getState().orgId,
  getOrgName: () => useAuthStore.getState().orgName,
  getRegion: () => useAuthStore.getState().region,
  getRole: () => useAuthStore.getState().role,
  getTeam: () => useAuthStore.getState().team,
  getUserTitle: () => useAuthStore.getState().userTitle,
  setAuth: (auth: Partial<Omit<AuthStoreState, 'setAuth' | 'clearAuth'>>) =>
    useAuthStore.getState().setAuth(auth),
  clearAuth: () => useAuthStore.getState().clearAuth(),
};
